var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoudlyCryingFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M23.6191 65.3335C23.0096 64.9335 22.2286 64.8763 21.581 65.2192C21.581 65.2192 21.581 65.2192 21.562 65.2192C18.6667 66.7049 18.3429 63.0858 15.6763 63.8668C13.2763 64.5716 7.96197 66.362 10.3429 68.0192C12.1524 69.2954 14.2477 67.8858 15.581 68.6668C18.1524 70.1525 18.0001 70.6096 20.1715 69.9049C24.3048 68.5525 23.3905 70.1335 26.362 70.6858C28.5144 71.0858 31.0667 70.362 32.2667 69.143C29.181 68.3239 26.2667 67.0287 23.6191 65.3335Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6858 64.7049C22.3238 64.8573 21.9619 65.0287 21.5619 65.2192C18.6667 66.7049 18.4572 63.8668 15.6762 63.8668C13.1048 63.8668 7.96194 66.3621 10.3429 68.0192C12.1524 69.2954 14.2477 67.8859 15.581 68.6668C18.1524 70.1525 18 70.6097 20.1715 69.9049C24.3048 68.5525 23.3905 70.1335 26.3619 70.6859C28.5143 71.0859 31.0667 70.362 32.2667 69.143C28.8 68.2287 25.5619 66.7049 22.6858 64.7049Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70.0952C56.8315 70.0952 70.4762 56.4506 70.4762 39.619C70.4762 22.7875 56.8315 9.14285 40 9.14285C23.1685 9.14285 9.5238 22.7875 9.5238 39.619C9.5238 56.4506 23.1685 70.0952 40 70.0952Z",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.4763 39.619C70.4763 56.4571 56.8382 70 40.0001 70.0952C23.2763 70.1714 9.60007 56.5143 9.52388 39.619C9.44769 22.7809 23.162 9.14285 40.0001 9.14285C56.8382 9.14285 70.4763 22.7809 70.4763 39.619Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8478 34.3428C30.8573 33.3332 25.543 33.7332 23.124 35.3142C21.8668 36.1332 17.0287 36.7047 19.4668 62.1523C22.1144 64.5904 25.2002 66.5523 28.5716 67.9237C21.1621 50.1523 28.4002 35.7904 29.8478 34.3428Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2287 61.3906C35.7525 60.1145 37.543 59.2764 40.0001 59.2764C42.4573 59.2764 44.2668 60.1145 47.7715 61.3906C51.0477 62.5716 52.8763 60.1145 52.5144 56.5335C51.2382 48.9906 45.7525 43.2002 40.0001 43.2002C34.4192 43.2002 29.0858 48.5335 27.6001 55.6954C26.8382 59.7145 28.7049 62.6478 32.2287 61.3906Z",
    fill: "url(#paint5_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3525 52.4383C49.1239 46.9906 44.6477 43.2002 40.0001 43.2002C35.3525 43.2002 30.8763 46.9906 28.6477 52.4383C28.7048 52.324 30.1334 49.3525 33.0858 49.9811C36.0953 50.6287 40.0001 50.7049 40.0001 50.7049C40.0001 50.7049 43.8858 50.6097 46.9144 49.9811C49.9429 49.3525 51.3525 52.4383 51.3525 52.4383Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 48.8571C42.4763 48.8571 44.9525 48.7428 47.4096 48.4952C47.181 48.2286 46.9525 47.9809 46.7049 47.7333C44.6858 45.6952 42.3049 44.5714 40.0001 44.5714C37.6953 44.5714 35.3144 45.6952 33.2953 47.7333C33.0477 47.9809 32.8191 48.2286 32.5906 48.4952C35.0477 48.7428 37.5239 48.8571 40.0001 48.8571Z",
    fill: "url(#paint7_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 54.4383C36.438 54.4383 31.4095 55.9621 30.2476 60.4954C31.1047 60.2478 32.1142 59.8478 32.8571 59.5621C35.0857 58.7049 37.5999 57.9049 39.9809 57.9049C42.3619 57.9049 44.8761 58.8764 47.1047 59.7526C47.8476 60.0383 48.8761 60.4383 49.7333 60.6859C48.6095 56.0573 43.5619 54.4383 39.9999 54.4383Z",
    fill: "url(#paint8_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2573 25.276C21.3335 26.4951 22.6859 27.1808 24.9525 27.0665C26.8763 26.9522 31.0478 25.657 33.7525 21.7522C34.2478 21.0284 33.4097 20.7046 32.8954 21.1808C31.1811 22.7998 26.4954 25.0284 22.724 24.8189C21.2192 24.7427 21.2573 25.276 21.2573 25.276Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9809 30.5905C27.9809 30.5905 33.4857 30.3048 35.6571 33.8667C35.7904 34.0953 35.8857 34.3429 35.9238 34.5905C36 35.1048 35.6 35.6953 34.5523 35.3524C28.0761 33.2 24.7619 34.781 22.2476 35.9238C21.2762 36.3619 20.1904 35.4286 20.5523 34.6286C22.3428 30.5905 27.9809 30.5905 27.9809 30.5905Z",
    fill: "url(#paint10_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.981 30.5905C27.981 30.5905 33.4858 30.3048 35.6572 33.8667C35.7334 34 35.8096 34.1334 35.8477 34.2857C32.5715 31.5619 28.0762 31.8096 28.0762 31.8096C28.0762 31.8096 23.8858 31.581 20.762 34.2096C22.7429 30.5905 27.981 30.5905 27.981 30.5905Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7428 25.276C58.6666 26.4951 57.3142 27.1808 55.0476 27.0665C53.1238 26.9522 48.9523 25.657 46.2476 21.7522C45.7523 21.0284 46.5904 20.7046 47.1047 21.1808C48.819 22.7998 53.5047 25.0284 57.2762 24.8189C58.7809 24.7427 58.7428 25.276 58.7428 25.276Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0192 30.5905C52.0192 30.5905 46.5144 30.3048 44.343 33.8667C44.2097 34.0953 44.1144 34.3429 44.0763 34.5905C44.0001 35.1048 44.4001 35.6953 45.4477 35.3524C51.9239 33.2 55.2382 34.781 57.7525 35.9238C58.7239 36.3619 59.8096 35.4286 59.4477 34.6286C57.6573 30.5905 52.0192 30.5905 52.0192 30.5905Z",
    fill: "url(#paint13_radial)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.019 30.5905C52.019 30.5905 46.5142 30.3048 44.3428 33.8667C44.2666 34 44.1904 34.1334 44.1523 34.2857C47.4285 31.5619 51.9238 31.8096 51.9238 31.8096C51.9238 31.8096 56.1142 31.581 59.238 34.2096C57.2571 30.5905 52.019 30.5905 52.019 30.5905Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4668 68.0573C16.0383 35.6763 21.6383 35.524 23.0668 34.7621C25.6002 33.3906 30.0383 32.9144 29.8478 34.343C29.6383 35.943 21.2764 37.4859 24.9906 68.0573",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M23.6191 65.3332C23.0096 64.9332 22.2286 64.8761 21.581 65.219C21.581 65.219 21.581 65.219 21.562 65.219C18.6667 66.7047 18.4572 63.9047 15.6763 63.8666C13.2953 63.8285 7.96198 66.3618 10.3429 68.019C12.1525 69.2951 14.2477 67.8856 15.581 68.6666C18.1525 70.1523 18.0001 70.6094 20.1715 69.9047C24.3048 68.5523 23.3906 70.1332 26.362 70.6856C28.5144 71.0856 31.0667 70.3618 32.2667 69.1428C29.181 68.3237 26.2667 67.0285 23.6191 65.3332Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M17.4668 68.0573C16.0383 35.6763 21.6383 35.524 23.0668 34.7621C25.6002 33.3906 30.0383 32.9144 29.8478 34.343C29.6383 35.943 21.2764 37.4859 24.9906 68.0573",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M17.4668 68.0573C16.0383 35.6763 21.6383 35.524 23.0668 34.7621C25.6002 33.3906 30.0383 32.9144 29.8478 34.343C29.6383 35.943 21.2764 37.4859 24.9906 68.0573",
    fill: "url(#paint18_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4668 68.0573C16.0383 35.6763 21.6383 35.524 23.0668 34.7621C25.6002 33.3906 30.0383 32.9144 29.8478 34.343C29.6383 35.943 21.2764 37.4859 24.9906 68.0573",
    fill: "url(#paint19_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M56.3811 65.3335C56.9907 64.9335 57.7716 64.8763 58.4192 65.2192C58.4192 65.2192 58.4192 65.2192 58.4383 65.2192C61.3335 66.7049 61.6573 63.0858 64.324 63.8668C66.724 64.5716 72.0383 66.362 69.6573 68.0192C67.8478 69.2954 65.7526 67.8858 64.4192 68.6668C61.8478 70.1525 62.0002 70.6096 59.8288 69.9049C55.6954 68.5525 56.6097 70.1335 53.6383 70.6858C51.4859 71.0858 48.9335 70.362 47.7335 69.143C50.8192 68.3239 53.7335 67.0287 56.3811 65.3335Z",
    fill: "url(#paint20_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3145 64.7049C57.6764 64.8573 58.0383 65.0287 58.4383 65.2192C61.3335 66.7049 61.543 63.8668 64.324 63.8668C66.8954 63.8668 72.0383 66.3621 69.6573 68.0192C67.8478 69.2954 65.7526 67.8859 64.4192 68.6668C61.8478 70.1525 62.0002 70.6097 59.8288 69.9049C55.6954 68.5525 56.6097 70.1335 53.6383 70.6859C51.4859 71.0859 48.9335 70.362 47.7335 69.143C51.2002 68.2287 54.4383 66.7049 57.3145 64.7049Z",
    fill: "url(#paint21_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1524 34.3428C49.1429 33.3332 54.4571 33.7332 56.8762 35.3142C58.1333 36.1332 62.9714 36.7047 60.5333 62.1523C57.8857 64.5904 54.8 66.5523 51.4286 67.9237C58.8381 50.1523 51.6 35.7904 50.1524 34.3428Z",
    fill: "url(#paint22_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5334 68.0573C63.962 35.6763 58.362 35.524 56.9334 34.7621C54.4 33.3906 49.9619 32.9144 50.1524 34.343C50.3619 35.943 58.7239 37.4859 55.0096 68.0573",
    fill: "url(#paint23_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M56.3811 65.3332C56.9907 64.9332 57.7716 64.8761 58.4192 65.219C58.4192 65.219 58.4192 65.219 58.4383 65.219C61.3335 66.7047 61.543 63.9047 64.324 63.8666C66.7049 63.8285 72.0383 66.3618 69.6573 68.019C67.8478 69.2951 65.7526 67.8856 64.4192 68.6666C61.8478 70.1523 62.0002 70.6094 59.8288 69.9047C55.6954 68.5523 56.6097 70.1332 53.6383 70.6856C51.4859 71.0856 48.9335 70.3618 47.7335 69.1428C50.8192 68.3237 53.7335 67.0285 56.3811 65.3332Z",
    fill: "url(#paint24_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M62.5334 68.0573C63.962 35.6763 58.362 35.524 56.9334 34.7621C54.4 33.3906 49.9619 32.9144 50.1524 34.343C50.3619 35.943 58.7239 37.4859 55.0096 68.0573",
    fill: "url(#paint25_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M62.5334 68.0573C63.962 35.6763 58.362 35.524 56.9334 34.7621C54.4 33.3906 49.9619 32.9144 50.1524 34.343C50.3619 35.943 58.7239 37.4859 55.0096 68.0573",
    fill: "url(#paint26_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5334 68.0573C63.962 35.6763 58.362 35.524 56.9334 34.7621C54.4 33.3906 49.9619 32.9144 50.1524 34.343C50.3619 35.943 58.7239 37.4859 55.0096 68.0573",
    fill: "url(#paint27_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.4763 39.619C70.4763 56.4571 56.8382 70 40.0001 70.0952C23.2763 70.1714 9.60007 56.5143 9.52388 39.619C9.44769 22.7809 23.162 9.14285 40.0001 9.14285C56.8382 9.14285 70.4763 22.7809 70.4763 39.619Z",
    fill: "url(#paint28_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.3562,
    y1: 67.3462,
    x2: 19.0593,
    y2: 67.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.4547,
    y1: 62.9899,
    x2: 20.9743,
    y2: 67.7864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0041 27.2681) scale(36.7656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.004 27.2682) scale(28.9253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 37.1109,
    y1: 51.1764,
    x2: 10.2627,
    y2: 50.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9436 52.6177) scale(8.11933)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 28.6524,
    y1: 47.8135,
    x2: 51.3505,
    y2: 47.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7663 47.1324) scale(8.01677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BCBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0034 56.9124) scale(8.66262 2.2083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 27.708,
    y1: 28.5917,
    x2: 27.6128,
    y2: 24.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0807 33.1894) rotate(-2.88189) scale(5.89127 2.6178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 28.301,
    y1: 26.696,
    x2: 28.301,
    y2: 34.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 52.2924,
    y1: 28.5917,
    x2: 52.3877,
    y2: 24.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9149 33.1896) rotate(-177.118) scale(5.89127 2.6178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 51.6993,
    y1: 26.696,
    x2: 51.6993,
    y2: 34.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 21.0471,
    y1: 22.2877,
    x2: 25.4384,
    y2: 70.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5715,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#17BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8891,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 25.2971,
    y1: 69.6378,
    x2: 17.2018,
    y2: 66.7807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 25.3923,
    y1: 37.2672,
    x2: 21.8368,
    y2: 54.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 24.0965,
    y1: 57.782,
    x2: 24.6679,
    y2: 66.5439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 23.5479,
    y1: 62.0209,
    x2: 23.5479,
    y2: 31.2907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0099D6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 51.6448,
    y1: 67.3463,
    x2: 60.9416,
    y2: 67.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 59.5463,
    y1: 62.99,
    x2: 59.0266,
    y2: 67.7864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 42.89,
    y1: 51.1765,
    x2: 69.7381,
    y2: 50.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 58.9538,
    y1: 22.2878,
    x2: 54.5626,
    y2: 70.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5715,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#17BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8891,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 54.7039,
    y1: 69.6378,
    x2: 62.7991,
    y2: 66.7807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 54.6086,
    y1: 37.2672,
    x2: 58.1642,
    y2: 54.6641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 55.9045,
    y1: 57.782,
    x2: 55.333,
    y2: 66.5439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 56.453,
    y1: 62.0209,
    x2: 56.453,
    y2: 31.2908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0099D6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.2625 64.4562) rotate(-90) scale(4.06349 12.6955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3541E",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#B26126",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8286,
    stopColor: "#DA843C",
    stopOpacity: 0.0836319
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#E89043",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoudlyCryingFace);
export default __webpack_public_path__ + "static/media/loudly-crying-face.33a7333119b0b78f74c07dcc8af4ac1d.svg";
export { ForwardRef as ReactComponent };